export const CHANNEL_TOKEN_HEADER = "token";
export const ACCOUNT_HEADER = "account";
export const USER_ID_HEADER = "userid";
export const PARENT_HEADER = "parent";
export const EXTERNAL_ID_HEADER = "externalId";
export const MESSAGE_TYPE_HEADER = "Message-Type";

export const SEND_PREVIEW_MESSAGE_SETTING = "sendPreviewMessage";